import React, { Component } from "react";
import { Collapse, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import "./style.css";

const menus = [
  { id: 1, title: "Home", link: "/home" },
  { id: 2, title: "About", link: "/about" },
  { id: 3, title: "Activities", link: "/case" },
  { id: 4, title: "Focus", link: "/focus" },
  {
    id: 5,
    title: "Get Involved",
    link: "#",
    submenu: [
      { id: 51, title: "Donate", link: "/donate" },
      { id: 52, title: "Volunteer", link: "/volunteer" },
    ],
  },
  { id: 6, title: "Contact", link: "/contact" },
];

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
    isOpen: 0,
  };

  // Toggle main menu open/close
  menuHandler = () => {
    this.setState({ isMenuShow: !this.state.isMenuShow });
  };

  // Toggle submenu collapse
  setIsOpen = (id) => () => {
    this.setState({ isOpen: id === this.state.isOpen ? 0 : id });
  };

  render() {
    const { isMenuShow, isOpen } = this.state;

    return (
      <div className="mobile-menu-wrapper">
        {/* Mobile Menu Container */}
        <div className={`mobileMenu ${isMenuShow ? "show" : ""}`}>
          <h2>Menu</h2>
          <ul className="responsivemenu">
            {menus.map((item) => (
              <li key={item.id}>
                {item.submenu ? (
                  <p onClick={this.setIsOpen(item.id)}>
                    {item.title}
                    <i
                      className={`fa ${
                        isOpen === item.id ? "fa-angle-down" : "fa-angle-right"
                      }`}
                    ></i>
                  </p>
                ) : (
                  <Link to={item.link} onClick={this.menuHandler}>
                    {item.title}
                  </Link>
                )}

                {/* Submenu */}
                {item.submenu && (
                  <Collapse isOpen={item.id === isOpen}>
                    <Card>
                      <CardBody>
                        <ul>
                          {item.submenu.map((submenu) => (
                            <li key={submenu.id}>
                              <Link
                                to={submenu.link}
                                className="active"
                                onClick={this.menuHandler}
                              >
                                {submenu.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </CardBody>
                    </Card>
                  </Collapse>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Menu Toggle (Hamburger Icon) */}
        <div className="showmenu" onClick={this.menuHandler}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </div>

        {/* Optional dark overlay behind open menu */}
        {isMenuShow && <div className="menu-overlay" onClick={this.menuHandler}></div>}
      </div>
    );
  }
}
